<template lang="html">
  <div :key="this.$route.name" class="pageContainer">
    <div class="container">

      <!-- Header -->
      <div class="row">
        <div class="col-12">
          <div class="header">
            <div class="header-top has-cover-photo" style="background-image: url('http://www.placehold.it/800x300')">
              <p class="name">{{ this.user.first }} {{ this.user.last }}</p>
              <ul class="edit-buttons">
                <li><button type="button" name="button" class="btn btn-sm btn-light">Edit Profile</button></li>
                <li><button type="button" name="button" class="btn btn-sm btn-light">Add Cover Photo</button></li>
              </ul>
            </div>
            <div class="header-bottom">
              <img v-if="this.user.photoURL" class="profileImage" :src="this.user.photoURL" alt="">
              <img v-if="!this.user.photoURL" class="profileImage" src="@/assets/img/emptyheadshot.png" alt="">
              <ul class="header-menu">
                <li><router-link :to="{ name: 'Profile' }">Timeline</router-link></li>
                <li><router-link :to="{ name: 'ProfileGoals' }">Goals</router-link></li>
                <li><router-link :to="{ name: 'ProfileFriends' }">Friends</router-link></li>
                <li><a class="dropdown">
                  <button class="dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">More</button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" href="#">Challenges</a>
                    <a class="dropdown-item" href="#">Badges</a>
                    <a class="dropdown-item" href="#">Groups</a>
                    <a class="dropdown-item" href="#">Wishlist</a>
                    <a class="dropdown-item" href="#">Dating</a>
                  </div>
                </a>
              </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <router-view></router-view>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import firebase from 'firebase'
import moment from 'moment'
import db from '@/store/firebaseinit'
import ProfileMain from '@/components/pages/ProfileMain'
import ProfileGoals from '@/components/pages/ProfileGoals'
import ProfileFriends from '@/components/pages/ProfileFriends'

export default {
  name: 'Profile',
  components: {
    ProfileMain,
    ProfileGoals,
    ProfileFriends,
  },
  data() {
    return {
      currentComponent: 'ProfileMain',
      componentsArray: ['ProfileMain', 'ProfileGoals', 'ProfileFriends'],
      user: 'No one',
      isMe: null,
    }
  },
  components: {
    'ProfileMain': ProfileMain,
    'ProfileGoals': ProfileGoals,
    'ProfileFriends': ProfileFriends
  },
  beforeRouteUpdate (to, from, next) {
    next()
  },
  created() {
    this.getInfo()
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    swapComponent(component) {
      this.currentComponent = component;
    },
    getInfo() {
      db.collection('users').where('username','==',this.$route.params.username).get()
      .then(result => {
        if(!result.empty) {
          result.forEach(doc => {
            this.user = doc.data()
            this.uid = doc.id
            if(firebase.auth().currentUser.uid == this.uid) {
              this.isMe = true
            } else {
              this.isMe = false
            }
          })
        } else {
          this.$router.push({ name: 'Error404' })
        }
      }).catch(error => {
        console.log('Could not query the database')
      })
    },
  },
}
</script>

<style scoped>
.header {
  margin-bottom: 30px;
  border: 1px solid #c9c9c9;
  border-top: none;
}
.header-top {
  background-image: none !important;
  background-color: grey;
  height: 170px;
}
.header-top.has-cover-photo {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 350px;
}
.header-top .name {
  position: absolute;
  bottom: 87px;
  left: 230px;
  font-size: 23px;
  font-weight: bold;
  color: #fff;
}
.header-top .edit-buttons {
  list-style-type: none;
  position: absolute;
  bottom: 87px;
  right: 33px;
  font-size: 23px;
  font-weight: bold;
}
.header-top .edit-buttons li {
  display: inline;
}
.header-menu {
  list-style-type: none;
  margin: 0;
  padding: 0;
  height: 54px;
  position: absolute;
  left: 215px;
  bottom: 15px;
}
.header-menu li {
  display: inline;
  padding: 0;
  margin: 0 -2px;
}
.header-menu li a {
  padding: 14px 18px;
  border-right: 1px dotted #c9c9c9;
}
.header-menu li a.is-active, .header-menu li a.is-active:hover {
  color: grey;
  cursor: default;
}
.header-menu li a:hover {
  text-decoration: none;
  color: #0056b3;
}
.header-menu li button:hover {
  cursor: pointer;
  color: #0056b3;
}
.header-menu li button {
  background: none;
  border: none;
  outline: none !important;
  color: #007bff;
}
.header-menu li button {
  background: none;
  border: none;
  outline: none !important;
}
.header-menu .dropdown-menu .dropdown-item {
  padding: 4px 15px;
  font-size: 14px;
}
.header-bottom .profileImage {
  margin: -130px 10px 20px 20px;
  border: 4px solid #fff;
  width: 160px;
  height: 160px;
  -webkit-box-shadow: 0px 0px 28px -7px rgba(0,0,0,0.17);
  -moz-box-shadow: 0px 0px 28px -7px rgba(0,0,0,0.17);
  box-shadow: 0px 0px 28px -7px rgba(0,0,0,0.17);
  background: #fff;
}

</style>


<!--

Post updates around goals
Shared goals
Meet ups
Challenges

-->



// WEBPACK FOOTER //
// src/components/pages/Profile.vue